var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6949_6622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.24971 9.43252L3.22555 7.40835C2.99805 7.18085 2.63055 7.18085 2.40305 7.40835C2.17555 7.63585 2.17555 8.00335 2.40305 8.23085L4.84138 10.6692C5.06888 10.8967 5.43638 10.8967 5.66388 10.6692L11.8355 4.49752C12.063 4.27002 12.063 3.90252 11.8355 3.67502C11.608 3.44752 11.2405 3.44752 11.013 3.67502L5.24971 9.43252Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6949_6622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.f437b6956ab21ec8c8869ae2fd7c2720.svg";
export { ForwardRef as ReactComponent };